import * as yup from 'yup'

const sftpSchema = yup.object().shape({
  isEnable: yup.boolean().default(true),
  protocol: yup
    .string()
    .oneOf(['FTP', 'SFTP'], 'Protocol must be FTP or SFTP')
    .default('SFTP'),
  host: yup.string().trim().required('Host is required'),
  port: yup
    .number()
    .typeError('Port must be a number')
    .required('Port is required')
    .integer('Port must be an integer')
    .min(1, 'Port must be between 1 and 65535')
    .max(65535, 'Port must be between 1 and 65535'),
  username: yup.string().trim().required('Username is required'),
  password: yup.string().trim().required('Password is required'),
  directory: yup.string().trim().required('Directory is required'),
})

export const instashopLastmileConfigSchema = yup.object().shape({
  secretKey: yup.string().trim().required('Secret Key is required'),
  isEnabled: yup.boolean().required(),
  apiKey: yup.string().trim().required('API Key is required'),
  baseUrl: yup.string().trim().required('Base URL is required'),
  aggIntWebhookUrl: yup
    .string()
    .trim()
    .required('AGG INT Webhook URL is required'),
  aggIntBearerToken: yup
    .string()
    .trim()
    .required('AGG INT Bearer Token is required'),
  googleMapApiKey: yup
    .string()
    .trim()
    .required('Google Map API Key is required'),
  reconciliationExportIsEnabled: yup.boolean().required(),
  reconciliationExportCronExpression: yup
    .string()
    .trim()
    .required('Reconciliation Export Cron Expression is required'),
  sftp: sftpSchema,
})

export type InstashopLastmileConfigFormFields = yup.InferType<
  typeof instashopLastmileConfigSchema
>
